import _ from 'lodash';

import { TaskType } from '@scale/shared-types';

type TaskTypeFormatter = (taskType: TaskType) => string;

interface Option {
  label: string;
  value: string;
}

export default function getTaskTypeSelectOptions(
  formatLabel: TaskTypeFormatter = _.identity,
): Option[] {
  return _.values(TaskType).map(taskType => {
    return {
      label: formatLabel(taskType),
      value: taskType,
    };
  });
}
